import React from 'react';
import { observer } from 'mobx-react';
import Styled from 'styled';

import Avatar from 'four-nets/avatar/avatar';

import defaultStyles from './avatar-view.scss';

export default Styled(defaultStyles)(
    observer(function AvatarView(props) {
        const { styles, user, alt } = props;

        return (
            <div className={styles.avatarWrapper}>
                <Avatar style={{ avatar: styles.avatar }} user={user} alt={alt} />
            </div>
        );
    })
);
